import React, { useEffect } from "react";
import { Icon } from "./CreateIcons.jsx";
import ThurentEventForm from "../redesign/components/ThurentEventForm";
import { CssBaseline, Stack, IconButton } from "@mui/material";
import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button } from "primereact/button";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import "./aboutpage_module.css";
import Services from "../ProviderServices.json";
import CreateEventCTA from "./EventServices/CreateEventCTA";
import { homePagePath } from "../constant";
import Navbar from "../redesign/components/Navbar";
import Footer from "../redesign/components/Footer";
import icon1 from "../assets/images/icon 9/Group 165.png";
import icon2 from "../assets/images/icon 9/Group 167.png";
import icon3 from "../assets/images/icon 9/handshake.png";
import icon4 from "../assets/images/icon 9/visibility.png";
import nick from "../assets/images/icon 8/nickimage.jpeg";
import rasheed from "../assets/images/icon 8/rasheed_2.png";


export const Aboutuspage = () => {
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const role = useSelector((state) => state.auth.role);

  const backtoHome = () => {
    isLoggedIn
      ? role === "customer"
        ? navigate("/dashboard")
        : navigate("/service-provider/dashboard")
      : navigate(homePagePath);
  };

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div style={{ width: "100%" }}>
      <CssBaseline />
      <Navbar />

      <div className={`main-container-aboutus ${!isLoggedIn && "no-auth"}`}>
        <div className="frontend-container-aboutus">
          {(!isLoggedIn || (isLoggedIn && role === "customer")) && (
            <div className="header-container-contact">
              <div className="event-service-list-contact sidebar">
                {Services.length > 0 &&
                  Services.map((item) => (
                    <Link
                      key={item.id}
                      className="event-service-list-link sidebar"
                      to={`/service/${item.slug}`}
                    >
                      <div className="event-service-button-data">
                        <div className="event-services-buttons-icons">
                          <Icon id={item.id} className="icon-default-color" />

                          <div>
                            <span>{item.serviceCardName}</span>
                          </div>
                        </div>
                      </div>
                    </Link>
                  ))}
              </div>
            </div>
          )}

          {/* Founder Section - Two Column Layout */}
          <div className="founders-section">
            <h2 className="founders-title">Meet Our Founders</h2>
            <div className="founders-grid">
              {/* Nick's Card */}
              <div className="founder-card">
                <div className="founder-image-wrapper">
                  <img src={nick} alt="Nagesh Kondoori (Nick)" className="founder-image" />
                </div>
                <div className="founder-content">
                  <h3 className="founder-name">Nagesh Kondoori (Nick)</h3>
                  <p className="founder-role">Founder & CTO</p>
                  <p className="founder-description">
                    Nick leads Thurent's product and technology. He built the platform that turns event chaos into coordination — stitching together checklists, vetted providers, booking workflows, and clear pricing so hosts can plan and order everything from one place. A product and engineering leader with 15+ years building software, he specializes in turning emerging AI into practical features people actually use, keeping Thurent fast, intelligent, and genuinely useful at every step of the host's journey.
                  </p>
                </div>
              </div>

              {/* Rasheed's Card */}
              <div className="founder-card">
                <div className="founder-image-wrapper">
                  <img src={rasheed} alt="Armstead Rasheed King III" className="founder-image" />
                </div>
                <div className="founder-content">
                  <h3 className="founder-name">Armstead Rasheed King III</h3>
                  <p className="founder-role">Co-Founder & CEO</p>
                  <p className="founder-description">
                    Armstead leads Thurent's vision, strategy, and growth. He built Thurent to bring order and calm to one of life's most stressful undertakings — hosting — turning a fragmented, offline process into one clear, guided, end-to-end experience. He brings a track record of leading complex programs and turning struggling teams into high-performing ones, with deep expertise in Agile delivery, program management, and operational execution under pressure. That operator's discipline is the engine behind how Thurent is built and how it scales: focused, accountable, and relentlessly oriented around getting things done for hosts.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="event-form-inner">
            <div
              className={`event-form-body ${isLoggedIn && role === "provider" ? "alter full" : "list"
                }`}
            >
              <div className="event-form-body-inner">
                <div
                  className="event-form-content event-service-content"
                  style={{ width: "100%" }}
                >
                  <div className="event-service-data-about">
                    <div className="blackbackgroundbody">
                      <span className="aboutus_headders">Our story</span>
                      <p className="about_us_para1">
                        Thurent connects hosts with trusted local vendors and walks you through every step, so hosting at home becomes smooth, predictable, and enjoyable. We were founded to fix a problem we kept running into ourselves: hosting at home means juggling tents, catering, decoration, priests, and a dozen other vendors across scattered channels. The real problem was never a lack of choices — it was coordination. Thurent stitches together checklists, vetted providers, booking workflows, and clear pricing so hosts can plan and order everything from one place. Think of Thurent as your event co-pilot — practical, local, and focused on getting things done.
                      </p>
                    </div>

                    <div className="bodytext">
                      <span className="showimage_with_header"> <span><img src={icon1} /></span> Our Mission</span>
                      <p className="about_us_para">
                        To empower hosts with the confidence, clarity, and convenience they need to organize events at home — by connecting them to reliable local service providers and guiding them step-by-step through the entire journey.
                        What We Do

                        Thurent simplifies every part of hosting:

                        Plan — A personalized event checklist tailored to your occasion, whether it's a housewarming, pooja, birthday, or anniversary.
                        Connect — Browse and book verified local providers for tents, catering, decoration, priests, and more, all in one place.
                        Coordinate — Follow a clear, guided workflow so nothing is missed, from pre-event prep to the final wrap-up.

                        By bringing hosts and providers onto one platform, Thurent owns the entire event journey rather than a single transaction — driving repeat engagement on the demand side and a growing provider network on the other.
                        Why We Exist

                        At-home events are a large, recurring, and deeply underserved market that still runs on word-of-mouth, scattered vendors, and manual coordination. Hosting should feel joyful, not stressful. Thurent bridges the gap between tradition and technology — making it easy for families to focus on what truly matters: celebrating together.
                      </p>
                    </div>
                    <div className="bodytext">
                      <span className="showimage_with_header"><span ><img className="aboutus_headders2" src={icon2} /></span> What We Do</span>
                      <p className="about_us_para">
                        Thurent simplifies every part of hosting:
                        Plan: Get a personalized event checklist tailored to your occasion — whether it's a housewarming, pooja, birthday, or anniversary.
                        Connect: Browse and book verified local providers for tents, catering, decoration, priests, and more — all in one place.
                        Coordinate: Follow a clear, guided workflow to ensure nothing is missed — from pre-event preparation to the final wrap-up.
                      </p>
                    </div>
                    <div className="bodytext">
                      <span className="showimage_with_header"><span ><img className="aboutus_headders2" src={icon3} /></span> Why We Exist</span>
                      <p className="about_us_para">
                        Hosting an event at home should feel joyful, not stressful. Thurent bridges the gap between tradition and
                        technology — making it easy for families to focus on what truly matters: celebrating together.
                      </p>
                    </div>
                    <div className="bodytext">
                      <span className="showimage_with_header"><span ><img className="aboutus_headders2" src={icon4} /></span> Our Vision</span>
                      <p className="about_us_para">
                        To become the most trusted event-hosting companion for every household — blending community, culture, and convenience into one seamless experience, and ultimately the connective layer for an entire ecosystem of home-based events.
                        Meet the Founders
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <ConfirmDialog />
    </div>
  );
};
export default Aboutuspage;